export default "__VITE_ASSET__D2D1WNq___"